import "./style.scss";
//import { TreeView } from "component/common/TreeView";
import { FormGroup, Label, Input } from "reactstrap";
import { getCommonApi } from "redux/actions/common";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withTranslation } from "react-i18next";
import "antd/dist/antd.css";
import {
  CarryOutOutlined,
  CheckOutlined,
  FormOutlined,
  MinusSquareOutlined,
} from "@ant-design/icons";
import { Select, Switch, Tree } from "antd";
import React, { useState, Component } from "react";
import "./style.scss";
import { getHierarchyList } from "redux/actions/customerPlus";

//import { GoPrimitiveDot } from "react-icons/go";

export class DownlineHierarchyClass extends Component {
  state = {
    datum: null,
    data: [],
    setData: [],
  };
  componentDidMount() {
    this.getHierarchyList({});
  }

  getHierarchyList = (data) => {
    this.props
      .getCommonApi(
        `customerreferral/hierarchylist/?referral_id=${this.props.id}`
      )

      .then((key) => {
        let { data } = key;
        let { HierarchyList } = this.state;
        if (data) {
          console.log(data, "key");
          this.setState({
            data: data,
          });
        }
      });
  };
  render() {
    const childArrays = (array, parentIndex) => {
      let items = [...array];

      return items.map((item, index) => {
        return (
          <div>
            {item?.childeren && item?.childeren?.length > 0 ? (
              <div
                style={{
                  display: "flex",
                }}
              >
                <div
                  style={{
                    height: 10,
                    width: 10,
                    borderRadius: 5,
                    marginTop: 5,

                    marginRight: 5,
                    backgroundColor: "#db3aa2",
                  }}
                  onClick={() => onClickChildArrayActive(parentIndex, index)}
                />
                <p>{item.label}</p>
              </div>
            ) : (
              <p>{item.label}</p>
            )}

            {item?.isActive && item.childeren && item.childeren?.length > 0 && (
              <div
                style={{
                  marginLeft: 30,
                }}
              >
                {childArrays(item.childeren, index)}
              </div>
            )}
          </div>
        );
      });
    };

    const onClickChildArrayActive = (parentIndex, childIndex) => {
      //  let { data } = key;
      let datass = [...this.state.data];
      datass[parentIndex].childeren[childIndex].isActive =
        !datass[parentIndex].childeren[childIndex].isActive;
      console.log(datass);

      this.setState({
        data: datass,
      });
    };

    const onClickActive = (item, index) => {
      // let { data } = HierarchyList;
      let datass = [...this.state.data];
      datass[index].isActive = !datass[index].isActive;
      this.setState({
        data: datass,
      });
    };

    return (
      <div className="col-12">
        {" "}
        <div className="App">
          <div>
            {this.state.data?.map((item, index) => {
              return (
                <div>
                  <div
                    style={{
                      display: "flex",
                      marginTop: 20,
                    }}
                  >
                    <div
                      style={{
                        height: 10,
                        width: 10,
                        borderRadius: 5,
                        marginTop: 5,

                        marginRight: 5,
                        backgroundColor: "#3c4087",
                      }}
                      onClick={() => onClickActive(item, index)}
                    />
                    <p className="fs-18">{item.label}</p>
                  </div>
                  {item?.isActive &&
                    item.childeren &&
                    item.childeren?.length > 0 && (
                      <div
                        style={{
                          marginLeft: 30,
                        }}
                      >
                        {childArrays(item.childeren, index)}
                      </div>
                    )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getCommonApi,
    },
    dispatch
  );
};

export const DownlineHierarchy = withTranslation()(
  connect(null, mapDispatchToProps)(DownlineHierarchyClass)
);
